<div class="number-cell">
  <div *ngIf="orderNumber">
    <b>Order:</b> {{ orderNumber }}
  </div>

  <div *ngIf="transactionNumber">
    <b>Transaction:</b> {{ transactionNumber }}
  </div>
</div>
